import React, { FC, forwardRef } from 'react';
import cx from 'classnames';
import { uid } from 'uid';
import useThemeBlock from '@/hooks/useThemeBlock';
import formBlock from '@/components/molecules/Form/block.json';
// styles
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
type InputCheckboxProps = InputProps &
	ThemeProps & {
		value?: string;
	};

/**
 * COMPONENT
 */
export const InputCheckbox: FC<InputCheckboxProps> = forwardRef(
	(
		{
			id = uid(),
			label,
			name,
			value = 'yes',
			required = false,
			disabled = false,
			invalid,
			inputAttributes,
			theme = {},
		},
		ref
	) => {
		const { blockTheme: formBlockTheme } = useThemeBlock(
			formBlock.slug,
			theme
		);

		const rootClass = cx(
			'supt-inputCheckbox supt-inputWrapper',
			getStyles(formBlockTheme)
		);

		return (
			<div className={rootClass}>
				<input
					id={id}
					className="supt-inputCheckbox__input"
					type="checkbox"
					name={name}
					value={value}
					required={required}
					disabled={disabled}
					ref={ref}
					aria-invalid={!!invalid}
					{...inputAttributes}
				/>
				<label
					htmlFor={id}
					className="supt-inputCheckbox__label"
					dangerouslySetInnerHTML={{ __html: label }}
				/>
				{invalid && typeof invalid === 'string' ? (
					<span role="alert" className="supt-inputCheckbox__error">
						{invalid}
					</span>
				) : null}
			</div>
		);
	}
);
